import { useEffect } from 'react';

export default function useMinuteAlignedTick(fn) {
  useEffect(() => {
    function msUntilNextMinute() {
      const now = new Date();
      return (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
    }

    let intervalId = null;
    const timeoutId = window.setTimeout(() => {
      fn();
      intervalId = window.setInterval(fn, 60_000);
    }, msUntilNextMinute());

    return () => {
      window.clearTimeout(timeoutId);
      if (intervalId) window.clearInterval(intervalId);
    };
  }, [fn]);
}
